export const termsOfUse = {
  move: {
    firstName: 'Move',
    fullName: 'MOVE SOLUÇÕES EM ELETROMOBILIDADE LTDA',
    document: '29.668.246/0001-18',
    address: 'Rua Irmão Calixto, bairro Saco dos Limões, Florianópolis/SC',
    email: 'contato@use-move.com',
  },
  chargerpro: {
    firstName: 'Charger Pro',
    fullName: 'CHARGERPRO SOLUCOES EM ENERGIA LTDA',
    document: '55.087.042/0001-01',
    address:
      'Rua Prof Atilio Innocenti, 474, bairro Vila Nova Conceicao, São Paulo/SP',
    email: 'contato@chargerpro.com.br',
  },
  mbenergia: {
    firstName: 'Recarga Verde',
    fullName: 'MB Soluções e Tecnologia em Energia e Engenharia',
    document: '54.890.550/0001-52',
    address:
      'Avenida Deputado Antonio Florencio de Queiroz, 3365, bairro Ponta Negra, Natal/RN',
    email: 'contato@mbenergia.com.br',
  },
  planetacharger: {
    firstName: 'Planeta Charger',
    fullName: 'Planeta Charger LTDA',
    document: '54.986.719/0001-72',
    address:
      'Av Professor Amaral, 23 Complemento: Andar 3 Bairro: Bezerros - PE',
    email: 'administrativo@planetacharger.com',
  },
  plugmove: {
    firstName: 'PlugMove',
    fullName: 'EWERTON A ROMANO',
    document: '55.654.257/0001-59',
    address:
      'EST MAURO DE PROSPERO, 1100, APT 22 TORRE IV Bairro: RESIDENCIAL DAS ILHAS Cidade: BRAGANCA PAULISTA - SP',
    email: 'plugmovebraganca@gmail.com',
  },
  nowcharge: {
    firstName: 'NOW Charge EV',
    fullName: 'NOW ELETROPOSTOS LTDA',
    document: '52.960.216/0001-00',
    address:
      'R SENADOR LUCIO BITENCOURT, 117, Bairro: CARLOS PRATES, BELO HORIZONTE - MG',
    email: 'diego@nowcharge.com.br',
  },
  poenergy: {
    firstName: 'PO ENERGY MOBILIDADE',
    fullName: 'PO ENERGY CONSULTORIA DE ENERGIA ELETRICA LTDA',
    document: '37.197.253/0001-07',
    address:
      'ST SHN QUADRA 02 - BLOCO A - SOBRELOJA 2, S/N Bairro: ASA NORTE CIDADE: BRASILIA-DF',
    email: 'app@poenergy.com.br',
  },
  echargerhub: {
    firstName: 'Moovolt',
    fullName: 'HCASTRO SISTEMAS DE MOBILIDADE LTDA',
    document: '52.316.815/0001-87',
    address:
      'Avenida Desembargador Moreira, Número 2020, sala 1104 CEP 60170-002, bairro Aldeota, Fortaleza-CE',
    email: 'contato@moovolt.com.br',
  },
  energia_atual: {
    firstName: 'Energia Atual',
    fullName: 'ENERGIA ATUAL LTDA',
    document: '46.859.676/0001-36',
    address: 'R IZIDORO LANGA, 194 CASA 4, Curitiba-PR',
    email: 'ricardo@energiaatual.com.br',
  },
  eletrix: {
    firstName: 'Eletrix',
    fullName: 'ELETRIX5 COMERCIO E SERVICOS LTDA',
    document: '51.055.198/0001-41',
    address:
      'Avenida Agua Fria, 467 - Complemento: Andar 11 Sala 116 - Bairro: Agua Fria, São Paulo - SP',
    email: 'app@eletrix5.com.br',
  },
  kuara_energy: {
    firstName: 'Kûara Energy',
    fullName: 'KUARA ENERGIA E CONSTRUCOES SUSTENTAVEIS',
    document: '41.966.386/0001-78',
    address:
      'Rua Francisco Arruda, 265 - Bairro Aleixo ,CEP: 69083-060- Manaus/AM',
    email: 'eletromobilidade@kuaraenergy.com',
  },
  oncharge: {
    firstName: 'On-Charge',
    fullName: 'On Charge Industria e Comércio Ltda',
    document: '52.561.208/0001-83',
    address: 'Rua MANOEL FURTADO NEVES 895, São Mateus do Sul - PR',
    email: 'comercial@oncharge.com.br',
  },
  trovaoeletrica: {
    firstName: 'TROVÃO MOBILIDADE ELÉTRICA',
    fullName: 'Trovao Eletrica e Automacao LTDA',
    document: '41.855.174/0001-13',
    address: 'Rua Dos Crisantemos, 66, Sala 1 - São Bernardo do Campo – SP',
    email: 'contato@trovaoeletrica.com.br',
  },
  azulenergia: {
    firstName: 'Azul Energia Eletropostos',
    fullName: 'VINATON COMERCIO E SERVICOS LTDA-ME',
    document: '17.506.112/0001-11',
    address: 'Rua Firmino Fontes, 77, Atalaia, Aracaju - SE, CEP 60110-535',
    email: 'vinicius.oliveira@vinaton.com.br',
  },
  synnuspower: {
    firstName: 'Synnus Power',
    fullName: 'SY TECH LTDA',
    document: '42.950.082/0001-85',
    address:
      'RUA SAO SEBASTIAO, 2304, ANDAR 2 SALA 25, Centro, São Carlos - SP, CEP 13560-230',
    email: 'Jefferson@synnus.com.br',
  },
  temcarregador: {
    firstName: 'Tem Carregador',
    fullName: 'Duo Telecom LTDA',
    document: '07.128.744/0001-35',
    address:
      'Rua Areolino de Abreu 1880 B, Centro, Teresina - PI, CEP 64000-180',
    email: 'dev@duotelecom.online',
  },
  evponto: {
    firstName: 'EV Ponto',
    fullName: 'Vavassori Engenharia Ltda',
    document: '45.974.132/0001-52',
    address:
      'Rua Professor Geraldo Von Sohsten, 114, Sala 00103 Bairro: Jaguaribe CIDADE: João Pessoa - PB CEP: 58015-190',
    email: 'jose.vavassori@vavassoriengenharia.com.br',
  },
  plug_charge: {
    firstName: 'PLUG CHARGE',
    fullName: 'CARIRI SOLAR ENERGIA SOLAR',
    document: '23.997.077/0001-83',
    address:
      'RUA DAS FLORES, Número: 224 Bairro: SALESIANOS, JUAZEIRO DO NORTE- CE CEP:63050-290',
    email: 'contato@caririsolar.com.br',
  },
  plugauto: {
    firstName: 'Plugauto',
    fullName: 'Ctrg Solucoes em Engenharia LTDA',
    document: '29.861.279/0001-80',
    address:
      'Rua Tiburcio Cavalcante 1958 Altos B, Bairro:Aldeota CIDADE: Fortaleza-CE CEP: 60125-045',
    email: 'thalissonpinheiro@gmail.com',
  },
  masterev: {
    firstName: 'MasterEV Driver',
    fullName:
      'MASTERCOIN DA AMAZONIA INDUSTRIA E COMERCIO DE ELETRO-ELETRONICOS LTDA',
    document: '08.211.271/0001-06',
    address:
      'Avenida Abiurana, 295 - Distrito Industrial I, Manaus - AM, 69.075-010',
    email: 'sac@mastercoin.com.br',
  },
  kapplanenergycharge: {
    firstName: 'Kapplan Energy Charge',
    fullName:
      'KAPPLAN ENERGY INDUSTRIA COMERCIO INSTALACOES ELETRICAS E SISTEMAS LTDA',
    document: '06.145.935/0001-42',
    address:
      'Rua Murilo Furtado 545 Galpão 2, Bairro: Parque Vitória CIDADE: São Paulo-SP CEP: 02270-000',
    email: 'walter.goncalves@kapplan.com.br',
  },
  myplugbrasil: {
    firstName: 'MY PLUG BRASIL',
    fullName: 'MY PLUG BRASIL LTDA',
    document: '51.766.534/0001-64',
    address:
      'Rod. Januário Carneiro, Número: 9339 Comp. Loja 06, Bairro: Vila da Serra, Nova Lima-MG CEP: 34006-057',
    email: 'ti@myplug.com.br',
  },
  r4charger: {
    firstName: 'R4 Charger',
    fullName: 'R4 GESTORA DE ENERGIA LTDA',
    document: '86.375.953/0001-50',
    address:
      'Rua Belém, Número 235, sala 04, CEP 89120-000, bairro Capitais, Timbó-SC',
    email: 'lucas.prestes@r4renovaveis.com.br',
  },
  ecofortteeletropostos: {
    firstName: 'Ecofortte Eletropostos',
    fullName: 'GLTR ELETROPOSTOS LTDA',
    document: '54.786.049/0001-40',
    address:
      'R. Francisco Rocha, Número: 198, Bairro: Batel, Curitiba - PR CEP: 80420-130',
    email: 'ecofortte@ecofortte.com',
  },
  rjeletropostos: {
    firstName: 'RJ Eletropostos',
    fullName:
      'SINDICATO DO COMERCIO VAREJISTA DE COMBUSTIVEIS LUBRIFICANTES E LOJAS DE CONVENIÊNCIA NO ESTADO DO RIO DE JANEIRO',
    document: '30.140.644/0001-46',
    address:
      'AVENIDA PRESIDENTE ROOSEVELT Bairro: SAO FRANCISCO, NITEROI - RJ, CEP: 24360-066',
    email: 'sindestado@sindestado.com.br',
  },
  rinno: {
    firstName: 'Rinno',
    fullName:
      'RINNO ENERGY DO BRASIL COMERCIO DE CARREGADORES DE VEICULO ELETRICO LTDA',
    document: '34.296.055/0001-02',
    address:
      'Rua Visconde do Rio Branco, 1341, Conj. 504, Centro, CEP 80420-210, na Cidade de Curitiba, Estado do Paraná',
    email: 'contato@rinnoenergy.com.br',
  },
  onenergy: {
    firstName: 'ON Energy Connect',
    fullName: 'ONENERGY LTDA',
    document: '54.091.472/0001-26',
    address:
      'Av. Senador Salgado Filho, 2850, Loja 06, Candelária, CEP 59064-000, na Cidade de Natal, Estado do Rio Grande do Norte',
    email: 'financeiro@onenergybr.com.br',
  },
  tcharge: {
    firstName: 'TCHARGE',
    fullName: 'AESP LOCACOES E SERVICOS LTDA',
    document: '34.182.558/0001-57',
    address:
      'Avenida Rio Grande do Sul, 1345, Sala 310, Bairro Estados, CEP 58030-021, no Município de João Pessoa, Estado da Paraíba',
    email: 'contact@etmsp.com',
  },
  vaga55: {
    firstName: 'Vaga55 Eletropostos',
    fullName: 'Vaga 55 Eletropostos LTDA',
    document: '55.556.739/0001-76',
    address:
      'RUA Sapucaia, número: 326 Conj 262 Torre The Mark, Bairro: Alto da Mooca Cidade: São Paulo-SP , CEP: 03170-050',
    email: 'contato@vaga55.com.br',
  },
  plugreen: {
    firstName: 'PluGreen',
    fullName: 'PLUGABR ELETROPOSTOS LTDA',
    document: '54.855.692/0001-89',
    address:
      'Praca Do Comercio, número: 200, Bairro: Catingal - Distrito, Cidade: Manoel Vitorino-BA, CEP: 45240-000',
    email: 'augusto.cardoso@plugreen.com.br',
  },
  sungate: {
    firstName: 'Viva Carro Eletrico',
    fullName: 'ANA PAULA SCHUNCK',
    document: '57.991.063/0001-74',
    address:
      'Rua Botafogo, número: 12, Bairro: Centro, Cidade: Parobé-RS, CEP: 95630-000',
    email: 'willian@sungate.com.br',
  },
  gatway: {
    firstName: 'Gatway Power',
    fullName: 'GATWAY FRANCHISING LTDA',
    document: '50.799.613/0001-09',
    address:
      'Rua Sao Sebastiao, 2304, Andar 2 Sala 02 Bairro: Centro, Cidade: Sao Carlos-SP, CEP: 13560-230',
    email: 'jefferson@gatway.com.br',
  },
  maxicharger: {
    firstName: 'MaxiCharger',
    fullName: 'MAXICHARGER CARREGADORES VEICULAR LTDA',
    document: '53.552.744/0001-85',
    address:
      'Rua Pernambuco, 639, Bairro: Nova Imperatriz, Cidade: Imperatriz-MA, CEP: 65907-270',
    email: 'maxchargerbr@gmail.com',
  },
  energybrasil: {
    firstName: 'Plug & Go',
    fullName: 'Energy Brasil Franchising LTDA',
    document: '33.748.395/0001-64',
    address:
      'Avenida Potirendaba, 4020 Bairro: Residencial Cidade Jardim Cidade: São José do Rio Preto - SP CEP: 15086-335',
    email: 'tarcisio.fonseca@grupoenergy.com.br',
  },
  neoenergia: {
    firstName: 'Mobility Neoenergia',
    fullName: 'NEOENERGIA SERVIÇOS S.A.',
    document: '04.780.652./0001-47',
    address:
      'Pr do Flamengo, 78 - 1º andar - Rio de Janeiro - RJ',
    email: 'impostos.diretos@neoenergia.com',
  },
  plugandcharge: {
    firstName: 'Plug&Charge Instaladora Equipamentos',
    fullName: 'Plug&Charge Instaladora de Equipamentos LTDA',
    document: '41.427.605/0001-40',
    address:
      'Rua Bocaiuva 441, Santa Quiteria - Curitiba - PR',
    email: 'plugueandcharge@gmail.com',
  },
  smartcenter: {
    firstName: 'Move',
    fullName: 'MOVE SOLUÇÕES EM ELETROMOBILIDADE LTDA',
    document: '29.668.246/0001-18',
    address: 'Rua Irmão Calixto, bairro Saco dos Limões, Florianópolis/SC',
    email: 'contato@use-move.com',
  },
  kromaconect: {
    firstName: 'KROMA CONECTA',
    fullName: 'KROMA CONECTA ELETROPOSTOS PARTICIPACOES S.A',
    document: '62.639.928/0001-78',
    address: 'Avenida Republica do Líbano 251, Sala 2603 e 2604, bairro Pina, Recife/PE',
    email: 'contato@use-move.com',
  },
  carregar: {
    firstName: 'Carregar',
    fullName: 'Carregar Ltda',
    document: '28.097.526/0001-50',
    address: 'Rua Gonçalves Dias, 904 4° andar, Belo Horizonte/MG',
    email: 'contato@use-move.com',
  },
  bidoo: {
    firstName: 'Bidoo',
    fullName: 'EV CHARGER MOBILIDADE LTDA',
    document: '50.767.152/0001-92',
    address: 'ESTR DOS BANDEIRANTES 15076 LOJ 208 PAV 2, Vargem Pequena - Rio de Janeiro/RJ',
    email: 'contato@use-move.com',
  },
  eletrocentro: {
    firstName: 'Eletrocentro',
    fullName: 'ELETROCENTRO INDUSTRIA E COMERCIO LTDA',
    document: '34.886.551/0002-05',
    address: 'Rua Ananias de Almeida, 379, Quitauna, Osasco-SP',
    email: 'contato@use-move.com',
  },
  ledax: {
    firstName: 'PONTO DE CARGA',
    fullName: 'PONTO DE CARGA ELETROMOBILIDADE E COMERCIO LTDA',
    document: '62.208.047/0001-00',
    address: 'Avenida Luís Viana Filho 6462 - Salvador Bahia',
    email: 'contato@use-move.com',
  },
  fwglocacao: {
    firstName: 'Plugueevá',
    fullName: 'FWG LOCACAO DE EQUIPAMENTOS LTDA',
    document: '13.203.238/0001-66',
    address:
      'Rua Josefina Ariza, 73, Bairro: Vila Nova Socorro, Mogi das Cruzes-SP, CEP: 08790-530',
    email: 'comercial@fwglocacao.com.br',
  },
};
